<template>
  <div class="is-fluid">
    <section class="box">
      <div
        v-if="hasCandidates && (isSchoolingOrder || hasSchoolingCandidates)"
        class=" p-b-sm"
      >
        <div class="columns has-text-centered">
          <div
            v-for="candidate in activeCandidates"
            class="column"
          >
            <div class="box candidate-box">
              <article class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <img
                      v-if="candidate.profile_photo"
                      width="200"
                      height="300"
                      :src="'/profiles/'+candidate.profile_photo"
                    >
                    <img
                      v-else
                      width="150"
                      height="300"
                      :src="'/img/icons/image.png'"
                    >
                  </figure>
                </div>
                <div class="media-content">
                  <div class="content">
                    <p class="title is-4 heading-line title has-text-weight-light">
                      <span>{{
                        candidate.first_name
                      }}</span>
                    </p>
                    <div class="subtitle is-6">
                      <div
                        v-if="candidateApplicationChoices(candidate)"
                        class=""
                      >
                        <span v-if="!candidateApplication(candidate).accepted">
                          {{ $t('shop.candidates.application') }}
                          <i>{{ candidateApplicationChoices(candidate).training_name }}</i>
                          -
                          <i>{{ candidateApplicationChoices(candidate).campus_name }}</i>
                        </span>
                        <span
                          v-if="candidateApplication(candidate).accepted && !candidateApplication(candidate).registration || candidateApplication(candidate).registration && !candidateApplication(candidate).registration.registered_candidate"
                        >
                          {{ $t('shop.candidates.accepted') }}
                          <i>{{ candidateApplicationChoices(candidate).training_name }}</i>
                          -
                          <i>{{ candidateApplicationChoices(candidate).campus_name }}</i>
                        </span>
                        <span
                          v-if="candidateApplication(candidate).registration && candidateApplication(candidate).registration.registered_candidate"
                        >
                          {{ $t('shop.candidates.registered') }}
                          <i>{{ candidateApplicationChoices(candidate).training_name }}</i>
                          -
                          <i>{{ candidateApplicationChoices(candidate).campus_name }}</i>
                        </span>
                      </div>
                      <div
                        v-else
                        class=""
                      >
                        <span>
                          {{ $t('shop.candidates.nograde') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <nav class="level is-mobile">
                    <div
                      v-if="$route.matched[0].meta.schoolType !== 'eschool'"
                      class="level-left"
                    >
                      <router-link
                        class="level-item"
                        :to="{ name: 'highschool-home', params: { school: $route.params.school }}"
                      >
                        <span>{{ $t('labels.general.edit') }}</span>
                      </router-link>
                    </div>
                    <div
                      v-else
                      class="level-left"
                    >
                      <router-link
                        class="level-item"
                        :to="{ name: 'eschool-home', params: { school: $route.params.school }}"
                      >
                        <span>{{ $t('labels.general.edit') }}</span>
                      </router-link>
                    </div>
                  </nav>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <div
        id="main-view"
        class="m-t-sm"
      >
        <transition
          name="component-fade"
          mode="out-in"
        >
          <component
            :is="mainView"
            :candidates="activeCandidates"
            @orderPage="displayOrder"
            @offer="displayOffer"
          />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import OrderCheckout from '../../components/OrderCheckout'
import Offers from '../../components/Index'
import OrderDetails from '../../components/orders/OrderDetails'

export default {

  data() {
    return {
      mainView: Offers,
    }
  },
  computed: {
    ...mapGetters('candidate', [
      'activeCandidates',
      'candidateApplication',
      'candidateApplicationChoices',
      'hasCandidates',
      'hasSchoolingCandidates'
    ]),
    ...mapGetters(
        'auth', [
          'getAccount',
          'isLoggedIn'
        ]
    ),
    ...mapGetters(
        'orders', [
          'isSchoolingOrder'
        ]
    ),
    ...mapGetters({
      schoolBySlug: 'organization/getSchoolBySlug',
    }),
    school() {
      if (this.schoolBySlug(this.$route.params.school)) {
        return this.schoolBySlug(this.$route.params.school).school_color
      }
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'highschool-categories' && to.hash === '#contact-form') {
        setTimeout(() => {
          this.$scrollTo('.contact-form', {offset: -30}, 500)
        }, 500)
      }
      if (to.name === 'highschool-checkout' || to.name === 'eshop-checkout') {
        this.displayPayment()
      }
      if (to.name === 'highschool-categories' || to.name === 'eshop-categories') {
        this.displayCategories()
      }
      if (to.name === 'highschool-order' || to.name === 'eshop-order') {
        this.displayOrder()
      }
      if (to.name === 'shop-offer') {
        this.displayCategories()
      }
    }
  },
  methods: {
    ...mapActions('auth', [
      'setAccount'
    ]),
    ...mapActions(
        'organization', [
          'fetchSchools'
        ]
    ),
    ...mapActions(
        'orders', [
          'setUserPendingCart',
          'setUserSavedItems',
          'setUserCheckedoutOrders',
          'setUserCompleteOrders'
        ]
    ),
    displayOffer() {
      this.mainView = Offers
    },
    displayPayment: function () {
      if (this.isLoggedIn) {
        this.mainView = OrderCheckout
      } else {
        if (this.$route.matched[0].meta.schoolType === 'highschool') {
          this.$router.push({name: 'connection-highschool', params: {school: this.$route.params.school}})
        }
        if (this.$route.matched[0].meta.schoolType === 'eschool') {
          this.$router.push({name: 'connection-eshop', params: {school: this.$route.params.school}})
        }

      }

    },
    displayOrder: function () {
      this.mainView = OrderDetails
    },
    displayCategories: function () {
      this.mainView = Offers
    },
  },
  created() {


    this.fetchSchools()
    this.setAccount()
    if (this.isLoggedIn) {

      this.setUserPendingCart(this.getAccount.id)
      this.setUserCheckedoutOrders(this.getAccount.id)
      this.setUserCompleteOrders(this.getAccount.id)
      this.setUserSavedItems(this.getAccount.id)
    }

    if (this.$route.name === 'highschool-checkout' || this.$route.name === 'eshop-checkout') {
      this.displayPayment()
    }
    if (this.$route.name === 'highschool-categories' || this.$route.name === 'eshop-categories') {
      this.displayCategories()
    }
    if (this.$route.name === 'highschool-order' || this.$route.name === 'eshop-order') {
      this.displayOrder()
    }

  }
}
</script>
<style>
.main-view {
  min-height: 38rem;
}

.candidate-box {
  min-height: 10em;
}

.column.has-vertically-aligned-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
